import { L_STORAGE_KEYS } from '@src/consts'
import { lStorage } from '@src/utils/'

import { OAuthClientParams } from './type'

export const setOAuthClientParams = (params: OAuthClientParams) => {
  const { clientId, responseType, redirectUrl, state } = params

  lStorage.removeItem(L_STORAGE_KEYS.UPSIDER_OAUTH_CLIENT_PARAMS)

  if (
    clientId === undefined ||
    responseType === undefined ||
    redirectUrl === undefined ||
    state === undefined
  ) {
    return
  }

  if (responseType !== 'code') {
    return
  }

  lStorage.setItem({
    key: L_STORAGE_KEYS.UPSIDER_OAUTH_CLIENT_PARAMS,
    value: {
      clientId,
      responseType,
      redirectUrl,
      state,
    },
  })
}
